import { SmoothMount } from '@shared/cove-ui';
import cx from 'classnames';
import { graphql, useStaticQuery } from 'gatsby';
import isUndefined from 'lodash/isUndefined';
import PropTypes from 'prop-types';
import s from './promoBanner.module.scss';

const CustomerSalesBanner = (props) => {
  const { active } = props;
  const { datoCmsSiteMetaInfo } = useStaticQuery(graphql`
    query NewPromoQuery6 {
      datoCmsSiteMetaInfo {
        promoBannerTitle2
        promoBannerTitleTextColor2 {
          hex
        }
        promoBannerBoldText2
        promoBannerBoldTextColor2 {
          hex
        }
        promoBannerText2
        promoBannerTextColor2 {
          hex
        }
        promoBannerBackgroundColor2 {
          hex
        }
      }
    }
  `);

  let bannerColor = '#274A67';
  let titleTextColor = '#FFFFFF';
  let boldTextColor = '#00cdb9';
  let textColor = '#FFFFFF';
  if (!isUndefined(datoCmsSiteMetaInfo)) {
    bannerColor = datoCmsSiteMetaInfo.promoBannerBackgroundColor2.hex;
    titleTextColor = datoCmsSiteMetaInfo?.promoBannerTitleTextColor2?.hex;
    boldTextColor = datoCmsSiteMetaInfo?.promoBannerBoldTextColor2?.hex;
    textColor = datoCmsSiteMetaInfo?.promoBannerTextColor2?.hex;
  }
  const title =
    datoCmsSiteMetaInfo.promoBannerTitle2 || 'Your promo has been applied';
  const boldText = datoCmsSiteMetaInfo.promoBannerBoldText2;
  const text = datoCmsSiteMetaInfo.promoBannerText2;
  return (
    <div
      className={cx(s.promo, {
        [s.promoHide]: !active,
      })}
    >
      <div
        className={cx(s.promoWrapper, s.promoBannerWrapper)}
        style={{ backgroundColor: bannerColor }}
      >
        <SmoothMount show={active}>
          <span className={s.promoTitle} style={{ color: titleTextColor }}>
            {title}{' '}
            <span className={s.promoTextBold} style={{ color: boldTextColor }}>
              {boldText}{' '}
            </span>
            <span className={s.promoText} style={{ color: textColor }}>
              {text}
            </span>
          </span>
        </SmoothMount>
      </div>
    </div>
  );
};

CustomerSalesBanner.propTypes = {
  active: PropTypes.bool,
};

CustomerSalesBanner.defaultProps = {
  active: true,
};

export default CustomerSalesBanner;
